import { render, staticRenderFns } from "./MitStoragePage.vue?vue&type=template&id=04c92dd0&scoped=true"
import script from "./MitStoragePage.vue?vue&type=script&lang=js"
export * from "./MitStoragePage.vue?vue&type=script&lang=js"
import style0 from "./MitStoragePage.vue?vue&type=style&index=0&id=04c92dd0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04c92dd0",
  null
  
)

export default component.exports